import api from './api';

export interface BillingStatus {
  subscriptionStatus: 'ACTIVE' | 'INACTIVE' | null;
  stripeSubscriptionId: string | null;
  stripeCustomerId: string | null;
  currentPeriodEnd: string | null;
  cancelAtPeriodEnd: boolean | null;
  amountCents: number | null;
  currency: string | null;
  planName: string | null;
}

type WrappedApiResponse<T> = {
  success: boolean;
  message: string;
  data: T;
};

const unwrap = <T>(payload: unknown): T => {
  const response = payload as WrappedApiResponse<T>;
  if (!response.success) throw new Error(response.message || 'Error en la operación');
  return response.data;
};

export const billingService = {
  async getStatus(): Promise<BillingStatus> {
    const res = await api.get<WrappedApiResponse<BillingStatus>>('/billing/status');
    return unwrap<BillingStatus>(res.data);
  },

  async createCheckoutSession(annual = false): Promise<{ url: string }> {
    const res = await api.post<WrappedApiResponse<{ url: string }>>(
      `/billing/create-checkout-session?annual=${annual}`
    );
    return unwrap<{ url: string }>(res.data);
  },

  async createPortalSession(): Promise<{ url: string }> {
    const res = await api.post<WrappedApiResponse<{ url: string }>>('/billing/portal-session');
    return unwrap<{ url: string }>(res.data);
  },
};
